export default __webpack_public_path__ + "static/media/volume.652fbf5d.svg";